// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Series list — compact, overflow-safe, mobile-first */

.match-grouping {
  padding: 8px 4px 32px;
  max-width: 820px;
  margin: 0 auto;
  min-height: 0;
  background: transparent;
  color: var(--vb-text);
  box-sizing: border-box;
}

.match-grouping-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
  padding: 4px 4px 0;
  background: transparent;
  border: none;
  box-shadow: none;
}

.match-grouping-header h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.03em;
  text-align: left;
  text-transform: none;
  color: var(--vb-text);
}

.back-btn,
.create-group-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 40px;
  padding: 8px 12px;
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  font-size: 13px;
  font-weight: 650;
}

.back-btn {
  background: var(--vb-surface);
  color: var(--vb-text);
}
.back-btn .btn-label { display: none; }

.create-group-btn {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
  border-color: transparent;
}

/* ---- Form ---- */
.create-group-form {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius);
  padding: 16px;
  margin-bottom: 14px;
  box-shadow: var(--vb-shadow-sm);
  position: relative;
  box-sizing: border-box;
}

.create-group-form h3 {
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 800;
  text-align: left;
  color: var(--vb-text);
}

.form-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-bottom: 10px;
}

.form-group {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.form-group.full-width { grid-column: 1 / -1; }

.form-group label {
  font-weight: 650;
  color: var(--vb-text-muted);
  font-size: 12px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid var(--vb-border-strong);
  border-radius: var(--vb-radius-sm);
  font-size: 16px;
  box-sizing: border-box;
  background: var(--vb-surface-2);
  color: var(--vb-text);
  font-family: inherit;
  min-height: 42px;
}

.form-group textarea { min-height: 64px; resize: vertical; }

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--vb-primary);
  box-shadow: 0 0 0 3px var(--vb-primary-soft);
}

.form-group .suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 0 0 10px 10px;
  z-index: 20;
  max-height: 180px;
  overflow-y: auto;
  box-shadow: var(--vb-shadow);
}

.form-group .suggestion-item {
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;
  color: var(--vb-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.form-group .suggestion-item:hover { background: var(--vb-surface-hover); }

.form-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--vb-border);
}

.save-btn, .cancel-btn {
  flex: 1 1;
  min-height: 42px;
  padding: 10px 14px;
  border: none;
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.save-btn { background: var(--vb-primary); color: var(--vb-primary-contrast); }
.cancel-btn {
  background: var(--vb-surface-2);
  color: var(--vb-text);
  border: 1px solid var(--vb-border);
}

/* ---- Cards ---- */
.match-groups-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.match-group-card {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 14px;
  padding: 10px 12px 10px;
  box-shadow: var(--vb-shadow-sm);
  min-width: 0;
  overflow: hidden;
}

.match-group-card.ongoing { box-shadow: inset 3px 0 0 var(--vb-warning); }
.match-group-card.teamA { box-shadow: inset 3px 0 0 var(--vb-success); }
.match-group-card.teamB { box-shadow: inset 3px 0 0 var(--vb-primary); }

.group-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
  margin-bottom: 8px;
}

.group-meta-left {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex: 1 1;
}

.group-org {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: var(--vb-text-muted);
  font-weight: 500;
}

.type-badge {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: var(--vb-radius-pill);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.type-badge.league { background: #dbeafe; color: #1d4ed8; }
.type-badge.tournament { background: #ffedd5; color: #c2410c; }
.type-badge.scrimmage { background: #dcfce7; color: #15803d; }
.type-badge.school { background: #f3e8ff; color: #7e22ce; }
body.night-mode .type-badge.league { background: rgba(37, 99, 235, 0.22); color: #93c5fd; }
body.night-mode .type-badge.tournament { background: rgba(234, 88, 12, 0.22); color: #fdba74; }
body.night-mode .type-badge.scrimmage { background: rgba(22, 163, 74, 0.22); color: #86efac; }
body.night-mode .type-badge.school { background: rgba(126, 34, 206, 0.22); color: #d8b4fe; }

.status-pill {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: var(--vb-radius-pill);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.status-pill.live { background: var(--vb-warning-soft); color: #b45309; }
.status-pill.done { background: var(--vb-success-soft); color: var(--vb-success); }
body.night-mode .status-pill.live { color: var(--vb-warning); }

.group-name {
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 700;
  color: var(--vb-text);
  text-align: left;
  text-transform: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.series-board {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.series-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 6px 8px;
  border-radius: 10px;
  background: var(--vb-surface-2);
}

.series-row.is-winner {
  background: var(--vb-success-soft);
}

.series-team-name {
  min-width: 0;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.25;
  color: var(--vb-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.series-row.is-winner .series-team-name { font-weight: 800; }

.series-pips {
  display: flex;
  gap: 3px;
  flex-shrink: 0;
}

.pip {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--vb-border-strong);
}

.pip.on { background: var(--vb-primary); }
.series-row.is-winner .pip.on { background: var(--vb-success); }

.series-set-score {
  font-family: var(--vb-font-score);
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
  min-width: 1.2em;
  text-align: right;
  color: var(--vb-text);
}

.group-note {
  margin: 8px 0 0;
  padding: 6px 8px;
  background: var(--vb-warning-soft);
  border-radius: 8px;
  font-size: 12px;
  color: var(--vb-text);
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.group-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
  min-width: 0;
}

.group-footer-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  min-width: 0;
  font-size: 11px;
  color: var(--vb-text-muted);
  font-weight: 600;
}

.group-footer-meta .dot { opacity: 0.5; }

.group-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.group-actions .view-btn,
.group-actions .icon-btn {
  min-width: 0;
  margin: 0;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.group-actions .view-btn {
  min-height: 32px;
  padding: 6px 12px;
  border-radius: 8px;
  background: var(--vb-navy);
  color: #fff;
  font-size: 12px;
  font-weight: 750;
}
body.night-mode .group-actions .view-btn {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
}

.group-actions .icon-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--vb-surface-2);
  color: var(--vb-text-muted);
  border: 1px solid var(--vb-border);
}

.group-actions .delete-btn:hover {
  background: var(--vb-danger-soft);
  color: var(--vb-danger);
  border-color: transparent;
}

.empty-state {
  text-align: center;
  padding: 40px 16px;
  color: var(--vb-text-muted);
  font-size: 14px;
}
.empty-state svg { margin-bottom: 10px; opacity: 0.4; }

.error-message {
  background: var(--vb-danger-soft);
  color: var(--vb-danger);
  padding: 10px 12px;
  border-radius: 10px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 650;
}

.loading {
  text-align: center;
  padding: 32px;
  font-size: 14px;
  color: var(--vb-text-muted);
}

@media (min-width: 640px) {
  .match-grouping { padding: 12px 8px 40px; }

  .match-grouping-header h1 { font-size: 20px; }
  .back-btn .btn-label { display: inline; }

  .form-row { grid-template-columns: 1fr 1fr; }
  .save-btn, .cancel-btn { flex: 0 0 auto; min-width: 132px; }

  .series-team-name { font-size: 14px; }
  .series-set-score { font-size: 26px; }
}

@media (max-width: 379px) {
  .series-pips { display: none; }
  .group-footer-meta { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/MatchGrouping.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA,uBAAuB,aAAa,EAAE;;AAEtC;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA,yBAAyB,mBAAmB,EAAE;;AAE9C;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,kCAAkC;EAClC,eAAe;EACf,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,uBAAuB,gBAAgB,EAAE,gBAAgB,EAAE;;AAE3D;;;EAGE,aAAa;EACb,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,kCAAkC;EAClC,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qCAAqC,mCAAmC,EAAE;;AAE1E;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,YAAY,6BAA6B,EAAE,iCAAiC,EAAE;AAC9E;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;AAClB;;AAEA,4BAA4B,2CAA2C,EAAE;AACzE,0BAA0B,2CAA2C,EAAE;AACvE,0BAA0B,2CAA2C,EAAE;;AAEvE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qCAAqC,mCAAmC,EAAE,cAAc,EAAE;AAC1F,yCAAyC,mCAAmC,EAAE,cAAc,EAAE;AAC9F,wCAAwC,mCAAmC,EAAE,cAAc,EAAE;AAC7F,qCAAqC,oCAAoC,EAAE,cAAc,EAAE;;AAE3F;EACE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA,oBAAoB,kCAAkC,EAAE,cAAc,EAAE;AACxE,oBAAoB,kCAAkC,EAAE,wBAAwB,EAAE;AAClF,oCAAoC,wBAAwB,EAAE;;AAE9D;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,0CAA0C,gBAAgB,EAAE;;AAE5D;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA,UAAU,6BAA6B,EAAE;AACzC,gCAAgC,6BAA6B,EAAE;;AAE/D;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,0BAA0B,YAAY,EAAE;;AAExC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;AACA,mBAAmB,mBAAmB,EAAE,YAAY,EAAE;;AAEtD;EACE,iCAAiC;EACjC,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB,sBAAsB,EAAE;;EAE1C,4BAA4B,eAAe,EAAE;EAC7C,uBAAuB,eAAe,EAAE;;EAExC,YAAY,8BAA8B,EAAE;EAC5C,yBAAyB,cAAc,EAAE,gBAAgB,EAAE;;EAE3D,oBAAoB,eAAe,EAAE;EACrC,oBAAoB,eAAe,EAAE;AACvC;;AAEA;EACE,eAAe,aAAa,EAAE;EAC9B,qBAAqB,aAAa,EAAE;AACtC","sourcesContent":["/* Series list — compact, overflow-safe, mobile-first */\n\n.match-grouping {\n  padding: 8px 4px 32px;\n  max-width: 820px;\n  margin: 0 auto;\n  min-height: 0;\n  background: transparent;\n  color: var(--vb-text);\n  box-sizing: border-box;\n}\n\n.match-grouping-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 12px;\n  padding: 4px 4px 0;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n}\n\n.match-grouping-header h1 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  text-align: left;\n  text-transform: none;\n  color: var(--vb-text);\n}\n\n.back-btn,\n.create-group-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 40px;\n  padding: 8px 12px;\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.back-btn {\n  background: var(--vb-surface);\n  color: var(--vb-text);\n}\n.back-btn .btn-label { display: none; }\n\n.create-group-btn {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n  border-color: transparent;\n}\n\n/* ---- Form ---- */\n.create-group-form {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius);\n  padding: 16px;\n  margin-bottom: 14px;\n  box-shadow: var(--vb-shadow-sm);\n  position: relative;\n  box-sizing: border-box;\n}\n\n.create-group-form h3 {\n  margin: 0 0 14px;\n  font-size: 16px;\n  font-weight: 800;\n  text-align: left;\n  color: var(--vb-text);\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.form-group {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.form-group.full-width { grid-column: 1 / -1; }\n\n.form-group label {\n  font-weight: 650;\n  color: var(--vb-text-muted);\n  font-size: 12px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  min-width: 0;\n  padding: 10px 12px;\n  border: 1px solid var(--vb-border-strong);\n  border-radius: var(--vb-radius-sm);\n  font-size: 16px;\n  box-sizing: border-box;\n  background: var(--vb-surface-2);\n  color: var(--vb-text);\n  font-family: inherit;\n  min-height: 42px;\n}\n\n.form-group textarea { min-height: 64px; resize: vertical; }\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--vb-primary);\n  box-shadow: 0 0 0 3px var(--vb-primary-soft);\n}\n\n.form-group .suggestions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 0 0 10px 10px;\n  z-index: 20;\n  max-height: 180px;\n  overflow-y: auto;\n  box-shadow: var(--vb-shadow);\n}\n\n.form-group .suggestion-item {\n  padding: 10px 12px;\n  cursor: pointer;\n  font-size: 14px;\n  color: var(--vb-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.form-group .suggestion-item:hover { background: var(--vb-surface-hover); }\n\n.form-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--vb-border);\n}\n\n.save-btn, .cancel-btn {\n  flex: 1;\n  min-height: 42px;\n  padding: 10px 14px;\n  border: none;\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.save-btn { background: var(--vb-primary); color: var(--vb-primary-contrast); }\n.cancel-btn {\n  background: var(--vb-surface-2);\n  color: var(--vb-text);\n  border: 1px solid var(--vb-border);\n}\n\n/* ---- Cards ---- */\n.match-groups-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.match-group-card {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 14px;\n  padding: 10px 12px 10px;\n  box-shadow: var(--vb-shadow-sm);\n  min-width: 0;\n  overflow: hidden;\n}\n\n.match-group-card.ongoing { box-shadow: inset 3px 0 0 var(--vb-warning); }\n.match-group-card.teamA { box-shadow: inset 3px 0 0 var(--vb-success); }\n.match-group-card.teamB { box-shadow: inset 3px 0 0 var(--vb-primary); }\n\n.group-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-width: 0;\n  margin-bottom: 8px;\n}\n\n.group-meta-left {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  flex: 1;\n}\n\n.group-org {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 12px;\n  color: var(--vb-text-muted);\n  font-weight: 500;\n}\n\n.type-badge {\n  flex-shrink: 0;\n  padding: 2px 8px;\n  border-radius: var(--vb-radius-pill);\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.type-badge.league { background: #dbeafe; color: #1d4ed8; }\n.type-badge.tournament { background: #ffedd5; color: #c2410c; }\n.type-badge.scrimmage { background: #dcfce7; color: #15803d; }\n.type-badge.school { background: #f3e8ff; color: #7e22ce; }\nbody.night-mode .type-badge.league { background: rgba(37, 99, 235, 0.22); color: #93c5fd; }\nbody.night-mode .type-badge.tournament { background: rgba(234, 88, 12, 0.22); color: #fdba74; }\nbody.night-mode .type-badge.scrimmage { background: rgba(22, 163, 74, 0.22); color: #86efac; }\nbody.night-mode .type-badge.school { background: rgba(126, 34, 206, 0.22); color: #d8b4fe; }\n\n.status-pill {\n  flex-shrink: 0;\n  padding: 2px 8px;\n  border-radius: var(--vb-radius-pill);\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n.status-pill.live { background: var(--vb-warning-soft); color: #b45309; }\n.status-pill.done { background: var(--vb-success-soft); color: var(--vb-success); }\nbody.night-mode .status-pill.live { color: var(--vb-warning); }\n\n.group-name {\n  margin: 0 0 6px;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--vb-text);\n  text-align: left;\n  text-transform: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.series-board {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.series-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  padding: 6px 8px;\n  border-radius: 10px;\n  background: var(--vb-surface-2);\n}\n\n.series-row.is-winner {\n  background: var(--vb-success-soft);\n}\n\n.series-team-name {\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 650;\n  line-height: 1.25;\n  color: var(--vb-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.series-row.is-winner .series-team-name { font-weight: 800; }\n\n.series-pips {\n  display: flex;\n  gap: 3px;\n  flex-shrink: 0;\n}\n\n.pip {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--vb-border-strong);\n}\n\n.pip.on { background: var(--vb-primary); }\n.series-row.is-winner .pip.on { background: var(--vb-success); }\n\n.series-set-score {\n  font-family: var(--vb-font-score);\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1;\n  min-width: 1.2em;\n  text-align: right;\n  color: var(--vb-text);\n}\n\n.group-note {\n  margin: 8px 0 0;\n  padding: 6px 8px;\n  background: var(--vb-warning-soft);\n  border-radius: 8px;\n  font-size: 12px;\n  color: var(--vb-text);\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.group-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 8px;\n  min-width: 0;\n}\n\n.group-footer-meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n  min-width: 0;\n  font-size: 11px;\n  color: var(--vb-text-muted);\n  font-weight: 600;\n}\n\n.group-footer-meta .dot { opacity: 0.5; }\n\n.group-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.group-actions .view-btn,\n.group-actions .icon-btn {\n  min-width: 0;\n  margin: 0;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.group-actions .view-btn {\n  min-height: 32px;\n  padding: 6px 12px;\n  border-radius: 8px;\n  background: var(--vb-navy);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 750;\n}\nbody.night-mode .group-actions .view-btn {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n}\n\n.group-actions .icon-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: var(--vb-surface-2);\n  color: var(--vb-text-muted);\n  border: 1px solid var(--vb-border);\n}\n\n.group-actions .delete-btn:hover {\n  background: var(--vb-danger-soft);\n  color: var(--vb-danger);\n  border-color: transparent;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 40px 16px;\n  color: var(--vb-text-muted);\n  font-size: 14px;\n}\n.empty-state svg { margin-bottom: 10px; opacity: 0.4; }\n\n.error-message {\n  background: var(--vb-danger-soft);\n  color: var(--vb-danger);\n  padding: 10px 12px;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.loading {\n  text-align: center;\n  padding: 32px;\n  font-size: 14px;\n  color: var(--vb-text-muted);\n}\n\n@media (min-width: 640px) {\n  .match-grouping { padding: 12px 8px 40px; }\n\n  .match-grouping-header h1 { font-size: 20px; }\n  .back-btn .btn-label { display: inline; }\n\n  .form-row { grid-template-columns: 1fr 1fr; }\n  .save-btn, .cancel-btn { flex: 0 0 auto; min-width: 132px; }\n\n  .series-team-name { font-size: 14px; }\n  .series-set-score { font-size: 26px; }\n}\n\n@media (max-width: 379px) {\n  .series-pips { display: none; }\n  .group-footer-meta { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
